  import React, { useState, useEffect } from "react";
  import DatePicker from "react-datepicker";
  import "react-datepicker/dist/react-datepicker.css";
  import { instance2 } from "../utils/axiosInstance"; // Ensure the Axios instance path is correct
  import CalendarIcon from "../img/calendaricon.svg"; // Replace with the correct path for your calendar icon
  import { formatNumber } from "../numberingformat"; // Ensure formatNumber works for formatting
  import DapurIcon from "../img/logodapursidebar.png";
  import { basecode } from "./pesananscreen/baserobotocode";
  import { useLocation } from "react-router-dom";
  import { jsPDF } from "jspdf"; // Import jsPDF for PDF generation
  import "jspdf-autotable"; // Import the autotable plugin for jsPDF
  import { useNavigate } from "react-router-dom";

  export default function PenerimaanBahan() {
    const navigate = useNavigate();
    const [locationId, setLocationId] = useState("");
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [editableRows, setEditableRows] = useState({});
    const [kitchenData, setKitchenData] = useState([]);
    const [sortDate, setSortDate] = useState("");
    const [sortKitchen, setSortKitchen] = useState(""); // For filtering by ingredient
    const kitchenId = parseInt(localStorage.getItem("locationId"),10)
      // Access state from the navigate call
      const location = useLocation();
    
      // Extract startDate and endDate from the URL query string
      const queryParams = new URLSearchParams(location.search);
      const startDate = queryParams.get('startDate');
      const endDate = queryParams.get('endDate');
    
      const [selectedDate, setSelectedDate] = useState(new Date(startDate));
    
  const localDateString = (thedate) =>{

    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, '0');  // Adding 1 because months are 0-based
    const day = String(thedate.getDate()).padStart(2, '0');
    
  console.log("startDate", thedate);
  const localDateString = `${year}-${month}-${day}`;

  return localDateString

  }
    const getWeekStartAndEndDates = (date) => {
      const current = new Date(date);
      const dayOfWeek = current.getDay();
      const monday = new Date(selectedDate? selectedDate : current);
      monday.setDate(current.getDate() - (dayOfWeek === 0 ? 6 : dayOfWeek - 1));

      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);

      return { startDate: localDateString(monday), endDate: localDateString(sunday)};
    };

    //const { startDate, endDate } = getWeekStartAndEndDates(selectedDate);

    useEffect(() => {
      const storedLocationId = localStorage.getItem("locationId");
      if (storedLocationId && !isNaN(storedLocationId)) {
        const parsedId = parseInt(storedLocationId, 10);
        setLocationId(parsedId);
      }
    }, []);

    useEffect(() => {
      const fetchDataForDate = async (date) => {
        if (!locationId) {
          console.log("Location ID not yet available.");
          return;
        }

        try {
          setLoading(true);
          setError(null);

          const response = await instance2.get(`draft_do/${locationId}/${localDateString(new Date(selectedDate))}/${localDateString(new Date(selectedDate))}`)
          // (`delivery_order_header/location_id/${locationId}`);
            // /${localDateString(new Date(startDate))}/${localDateString(new Date(endDate))}`);
          const retrievedData = response.data?.data || response.data || [];
          //console.log(`delivery_order/location/${locationId}/${localDateString(new Date(startDate))}/${localDateString(new Date(endDate))}`)
          console.log(`draft_do/${locationId}/${localDateString(new Date(selectedDate))}/${localDateString(new Date(selectedDate))}`)
          setData(retrievedData);
          setFilteredData(retrievedData)
          // Set editable rows state
          const initialEditableState = retrievedData.reduce((acc, item, index) => {
            acc[index] = {
              date_request: item.date_request,
              ingredient_id: item.ingredient_id,
              kitchen_id: item.kitchen_id,
              ingredient_value: item.qty_order,
              edited_qty: item.qty_order, 
              qty_do: item.qty_do, 
              remaining_qty: item.qty_order - item.edited_qty, 
              qty_order: item.qty_order,
              cumulative_sum: item.stock, 
              uoq_id: item.uoq_id, 
              order_id: item.order_id, 
              order_no: item.order_no, 
              delivery_date: item.date_request, 
              do_exists: item.do_exist, 
              do_qty: item.do_qty
            };
            return acc;
          }, {});
          setEditableRows(initialEditableState);
          // console.log("initial", initialEditableState)
        } catch (err) {
          setError(err.message || "Failed to fetch data");
        } finally {
          setLoading(false);
        }
      };

      if (locationId) {
        fetchDataForDate(selectedDate? selectedDate : startDate);
      }
    }, [startDate,endDate,  selectedDate, locationId]);

    const handleOrderQtyChange = (index, value) => {
      setEditableRows((prev) => {
        const updatedRows = { ...prev };
        updatedRows[index] = { ...updatedRows[index], edited_qty: value };
        return updatedRows;
      });
    };

    const calculateEditableQtyAndRemainingQty = (index, data) => {
      let editableQty, remainingQty, cumulativeSum;

      for (let i = 0; i <= index; i++) {    
        if (i > 0 && data[i].ingredient_name !== data[i - 1].ingredient_name) {
        cumulativeSum = (data[index].qty_received, editableRows[i].edited_qty);} else 
        cumulativeSum = parseInt(cumulativeSum? cumulativeSum : 0) + parseInt(editableRows[i]?.edited_qty );
      }
    
      // For the first row or when ingredient_name changes:
      // if (index === 0 || data[index - 1].ingredient_name !== data[index].ingredient_name) {
      //   editableQty = Math.min(data[index].qty_received, data[index].ingredient_value); // First row: Min of qty_received and ingredient_value
      //   remainingQty = (data[index].qty_received - cumulativeSum); // Remaining quantity after first row's edited_qty
      // } else {
        // For subsequent rows:
        // editable_qty is determined based on the previous remaining_qty and ingredient_value
        editableQty = 0;
        // Math.min(editableRows[index - 1]?.remaining_qty, data[index].qty_request); // Max between previous remaining qty and ingredient_value
        
        // Calculate cumulative sum for the current row
        
        // Calculate remaining qty after deducting cumulative sum
        remainingQty = (data[index]?.qty_received - cumulativeSum); // Calculate remaining qty
      // }
    
      return { editableQty, remainingQty, cumulativeSum };
    };
    //wew
    const handleSubmit = async () => {
      const editedData = Object.values(editableRows).map((row) => ({
        id: row.id,
        qty: row.edited_qty, // Submit raw numeric value
        location_id: locationId, // Submit raw numeric value
        ingredient_id: row.ingredient_id, // Submit raw numeric value
        kitchen_id: row.kitchen_id, // Submit raw numeric value
        uoq_id: row.uoq_id, // Submit raw numeric value
        delivery_date: localDateString(new Date(row.date_request)), // Submit raw numeric value
        admin_id: localStorage.getItem("userAuthentication"), // Submit raw numeric value
        order_id: row.order_id, // Submit raw numeric value
        order_no: sortDate && sortKitchen ? nomorDo : null
      }));
      //console.log("date request",localDateString(new Date(editedData[0].delivery_date)))
  //console.log("show",editedData)
      try {
        const response = await instance2.post("/delivery_order", {
          locationId,
          editedData,
        });


        if (response.status === "OK") {
          alert("Data submitted successfully");
        } else {
          alert("Submission failed");
        }
      } catch (error) {
        console.error("Error during submission", error);
        alert("An error occurred while submitting the data");
      }
    };
    const handleSubmitAndNavigate = async () => {
      await handleSubmit();
      navigate(`/penerimaanbahansortbydapur?kitchenId=${sortKitchen}&startDate=${localDateString(new Date(sortDate))}&endDate=${localDateString(new Date(sortDate))}`); // Change this route to your desired destination
    };

    


    // Filter data when sortSupplier or sortIngredient changes
    useEffect(() => {
      const filteredKitchen = data.filter((item) =>
         String(item.kitchen_id) === sortKitchen 
    );
    let filtered = data
      sortKitchen ?  filtered = filteredKitchen : filtered = data;

      if (sortDate) {
        // Ensure to format the date correctly for comparison
        filtered = filtered.filter((item) => item.date_request === sortDate);
      }
      
      setFilteredData(filtered)

      const initialEditableState = filtered.reduce((acc, item, index) => {
        acc[index] = {
          date_request: item.date_request,
          ingredient_id: item.ingredient_id,
          kitchen_id: item.kitchen_id,
          ingredient_value: item.qty_order,
          edited_qty: item.qty_order, // Initially, set it to ingredient_value
          remaining_qty: item.qty_order - item.edited_qty, // Remaining qty after ingredient value is set
          qty_received: item.qty_received,
          cumulative_sum: item.stock, // Start the cumulative sum with ingredient_value
          uoq_id: item.uoq_id, // Start the cumulative sum with ingredient_value
          order_id: item.order_id, // Start the cumulative sum with ingredient_value
          order_no: item.order_no, // Start the cumulative sum with ingredient_value
          delivery_date: item.date_request, // Start the cumulative sum with ingredient_value
        };
        return acc;
      }, {});
      setEditableRows(initialEditableState);
      
     // console.log("data2",filteredData, sortKitchen, filtered); // Store the filtered data in filteredData state
    }, [sortDate, sortKitchen, data]); // Filter when sortDate or data changes

 

    useEffect(() => {
      const fetchKitchen = async () => {
     try {
      const response = await instance2.get(`kitchen/location/${parseInt(localStorage.getItem("locationId"),10)}`);
          const kitchen = response.data?.data || response.data || [];
          
      setKitchenData(kitchen)
     } catch (err) {
      setError(err.message || "Failed to fetch data");
    } finally {
      setLoading(false);
    }
  } 
  fetchKitchen()
  //console.log("data",kitchenData)
; // Store the filtered data in filteredData state
    }, []); // Filter when sortDate or data changes

    


    
    const handleDownloadPDF = async (orderNumber, orderDetails, supplierName, orderDate) => {
      const doc = new jsPDF();
    
      // Embed the Roboto font (add the correct base64 font data here)
      const robotoFont = basecode; // Replace with base64-encoded Roboto font data
      doc.addFileToVFS('Roboto-Regular.ttf', robotoFont);
      doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
      doc.setFont('Roboto', 'normal'); // Set default font to Roboto
    
      // Convert local icon to Base64
      const loadImageAsBase64 = (imgSrc) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'Anonymous';
          img.src = imgSrc;
          img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL('image/png'));
          };
          img.onerror = (err) => reject(err);
        });
    
      // Load icon
      const iconBase64 = await loadImageAsBase64(DapurIcon);
    
      // Title and Supplier Information Block
      const pageWidth = doc.internal.pageSize.width;
      const text = 'PURCHASE ORDER';
      const textWidth = doc.getTextWidth(text);
      const xPosition = (pageWidth - textWidth) / 2;
    
      const addHeader = (doc, pageWidth, supplierName, orderNumber, orderDate) => {
        doc.setFontSize(12);
        doc.text(text, xPosition, 10);
    
        const supplierInfo = {
          Pemasok: supplierName,
          Nomor: orderNumber,
          'Tanggal': new Date(orderDate).toLocaleDateString('id-ID', {
            year: 'numeric',
            month: 'long',
            day: '2-digit',
          }),
        };
    
        const marginLeft = 10;
        const textYOffset = 20;
        const labelWidth = Math.max(
          ...Object.keys(supplierInfo).map((key) => doc.getTextWidth(`${key}   `))
        );
    
        let yOffset = textYOffset;
        Object.entries(supplierInfo).forEach(([key, value]) => {
          doc.text(`${key}`, marginLeft, yOffset);
          const colonX = marginLeft + labelWidth;
          doc.text(':', colonX, yOffset);
          const valueX = colonX + 2;
          doc.text(value, valueX, yOffset);
    
          yOffset += 5;
        });
    
        const iconWidth = 23;
        const iconHeight = 18;
        const iconX = pageWidth - iconWidth - 10;
        const iconY = textYOffset - 6;
        doc.addImage(iconBase64, 'PNG', iconX, iconY, iconWidth, iconHeight);
      };
    
      let yOffset = 40;
      const totalPageHeight = doc.internal.pageSize.height;
      let pageNumber = 1;
    
      const addFooter = (currentPage, totalPages) => {
        const footerText = `Page ${currentPage} of ${totalPages}`;
        doc.setFontSize(10);
        doc.text(footerText, pageWidth - doc.getTextWidth(footerText) - 10, totalPageHeight - 10);
      };
    
      addHeader(doc, pageWidth, supplierName, orderNumber, orderDate);
    
      // Initialize grand total
  let grandTotal = 0;

  // Loop through order details
  Object.entries(orderDetails).forEach(([deliveryDate, items], index) => {
    const sectionHeight = items.length * 5 + 26;

    // Check for page break
    if (yOffset + sectionHeight > totalPageHeight - 20) {
      doc.addPage();
      yOffset = 40;
      pageNumber += 1;
      addHeader(doc, pageWidth, supplierName, orderNumber, orderDate);
    }

    // Calculate section subtotal
    const sectionSubtotal = items.reduce(
      (sum, item) => sum + (parseFloat(item.price_total) || 0),
      0
    );
    grandTotal += sectionSubtotal; // Add to grand total

    // Draw gray border for the section
    doc.setDrawColor(200, 200, 200);
    doc.rect(10, yOffset, pageWidth - 20, sectionHeight, 'S');

    // Add delivery date
    doc.setFontSize(10);
    doc.text(
      `Delivery Date: ${new Date(deliveryDate).toLocaleDateString('id-ID', {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
      })}`,
      15,
      yOffset + 5
    );

    yOffset += 7;

    // Add table for items
    doc.autoTable({
      startY: yOffset,
      head: [['#', 'Bahan', 'Jumlah', 'Unit', 'Harga/Unit', 'Subtotal']],
      body: items.map((item, index) => [
        `${index + 1}.`,
        item.ingredient_name || '-',
        formatNumber(item.order_qty), // Formatted
        item.uoq_code || '-',
        formatNumber(item.price_unit) || '-', // Formatted
        formatNumber(item.price_total) || '-', // Formatted
      ]),
      columnStyles: {
        0: { halign: 'center', cellWidth: '5%' },
        1: { halign: 'left', cellWidth: 120 },
        2: { halign: 'right', cellWidth: '10%' },
        3: { halign: 'center', cellWidth: '5%' },
        4: { halign: 'right', cellWidth: '10%' },
        5: { halign: 'right', cellWidth: '10%' },
      },
      styles: {
        cellPadding: 1,
        fontSize: 8,
        overflow: 'linebreak',
        font: 'Roboto',
      },
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
      },
    });

    // Update yOffset for next section
    yOffset = doc.lastAutoTable.finalY + 5;

  // Set font size to 8 for subtotal
  doc.setFontSize(8);
  doc.text(`Subtotal: ${formatNumber(sectionSubtotal)}`, pageWidth - 60, yOffset);
  yOffset += 10; // Adjust yOffset for next section
  });

  // Display grand total
  doc.text(`Grand Total: ${formatNumber(grandTotal)}`, pageWidth - 60, yOffset);
      
    
      const pageCount = doc.internal.getNumberOfPages();
    
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        addFooter(i, pageCount);
      }
    
      doc.save(`${orderNumber}.pdf`);
    };

    const nomorDo = sortDate && sortKitchen
  ? `${kitchenData.find((item) => item.id === parseInt(sortKitchen))?.name || "Unknown"}/${localDateString(new Date(sortDate))}`
  : ``;

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // Initial check for mobile
   // Update the state based on screen width
   useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1000); // Set to true if width <= 768px
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    return (
      <div className="p-10 flex flex-col gap-6">
        <div className="flex flex-col items-center gap-4">
          <div className="border-t border-gray-400 w-full flex-1"></div>
          <div className="flex flex-col w-full">
            <p className="text-3xl font-medium">Delivery Order</p>
            </div>
          <div className="flex flex-row w-full items-center justify-start">
            {/* <div className="font-semibold">Tanggal:</div>
            <DatePicker
              selected={selectedDate? selectedDate : startDate}
              onChange={(date) => setSelectedDate(date)}
              customInput={
                <CustomInput
                  value={selectedDate? selectedDate : startDate.toLocaleDateString("id-ID", {
                    year: "numeric",
                    month: "long",
                    day: "2-digit",
                  })}
                  isOpen={isOpen}
                />
              }
              onCalendarOpen={() => setIsOpen(true)}
              onCalendarClose={() => setIsOpen(false)}
              dateFormat="yyyy-MM-dd"
              filterDate={(date) => {
                const day = date.getDay();
                return day !== 0 && day !== 6; // Disable weekends
              }}
            /> */}
          </div>
          
          <div className={`${isMobile ? 'flex-col w-full gap-10 items-center justify-between' : 'flex w-full gap-10 items-center justify-between'}`}>
          <div className="flex gap-4 items-center text-xxs md:text-xxs lg:text-base">
                <label className="text-md text-black">Tanggal</label>
                <select
                  value={sortDate}
                  onChange={(e) => setSortDate(e.target.value)}
                  className="px-8 py-2 border-transparent rounded-[25px] text-xxs md:text-xxs lg:text-base"
                >
                  <option value="">Semua</option>
                  {[...new Set(data.map((item) => item.delivery_date))].map(
                    (date, index) => (
                      <option key={index} value={date}>
                        {new Date(date).toLocaleDateString("id-ID", {
                          year: "numeric",
                          month: "long",
                          day: "2-digit",
                        })}
                      </option>
                    )
                  )}
                </select>
    <label className="text-md text-black">Dapur</label>
    <select
      value={sortKitchen}
      onChange={(e) => setSortKitchen(e.target.value)}
      className="px-8 py-2 border-transparent rounded-[25px] text-xxs md:text-xxs lg:text-base"
    >
      <option value="">Semua</option>

      
      {kitchenData.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))
      }
    </select>
  </div>
  <h1 className="font-bold text-xxs md:text-xxs lg:text-base  ">Nomor DO : {(sortDate === "" || filteredData.some(item => item.qty_do !== null)) ? 
    <span className="text-2xl px-10">{nomorDo}</span> : <span className="text-red-500">Belum Ada</span> }</h1>
  <div className="flex gap-4 items-center">
  <button
            
              className={(sortDate === "" || filteredData.some(item => item.qty_do !== null)) ? "px-8 py-4 bg-gray-200 text-white rounded-[50px] uppercase text-xxs md:text-xxs lg:text-base" :
                "px-8 py-4 bg-merah-no text-white rounded-[50px] hover:bg-merah-hover uppercase text-xxs md:text-xxs lg:text-base"}
            onClick={handleSubmitAndNavigate}
            disabled = {(sortDate === "" || filteredData.some(item => item.qty_do !== null))}

          >
            Buat Delivery Order
          </button><button
            
            className={(sortKitchen === "" || sortDate === "" || filteredData.some(item => item.qty_do === null)) ? "px-8 py-4 bg-gray-200 text-white rounded-[50px] uppercase text-xxs md:text-xxs lg:text-base" :
              "px-8 py-4 bg-merah-no text-white rounded-[50px] hover:bg-merah-hover uppercase text-xxs md:text-xxs lg:text-base"}
          onClick={handleSubmitAndNavigate}
          disabled = {(sortKitchen === "" || sortDate === "" || filteredData.some(item => item.qty_do === null))}
        >
          Lihat Delivery Order
        </button>
          
        </div>
              </div>
          <div className="border-t border-gray-400 w-full flex-1"></div>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <div className="overflow-x-auto">
            {data.length > 0 ? (
              <table className="table-fixed border-collapse w-full text-left">
                <thead>
                  <tr className="bg-white">
                    
                  <th className="border-b border-gray-400 px-4 py-2 uppercase text-left">Dapur</th>
                  <th className="border-b border-gray-400 px-4 py-2 uppercase text-left">Bahan</th>
                  {/* <th className="border-b border-gray-400 px-4 py-2 uppercase text-right">Tanggal</th> */}
                  <th className="border-b border-gray-400 px-4 py-2 uppercase text-right">Kebutuhan</th>
                    <th className="border-b border-gray-400 px-4 py-2 uppercase text-right">
                      stock
                    </th><th className="border-b border-gray-400 px-4 py-2 uppercase text-left">
                      pengiriman
                    </th>
                    <th className="border-b border-gray-400 px-4 py-2 uppercase text-center rounded-tr-[15px]">
                      Selisih
                    </th>
                    {/* <th className="border-b border-gray-400 px-4 py-2 uppercase text-center rounded-tr-[15px]">
                      Download PDF
                    </th> */}
                  </tr>
                </thead>
                {Object.values(
  filteredData.reduce((groups, item, index) => {
    // Group data by `date_request`
    if (!groups[item.date_request]) {
      groups[item.date_request] = [];
    }
    groups[item.date_request].push({ ...item, index });
    return groups;
  }, {})
).map((group, groupIndex) => {
  // Determine the background color for the group
  // const bgColor = groupIndex % 2 === 0 ? "bg-gray-200" : "bg-white";
  
  // // The rowSpan for the date will be the number of items in this group
  // const rowSpan = group.length;

  return (
    <tbody key={groupIndex}>
      {/* Add a row for the Delivery Date header */}
      <tr>
        <td
          className="border-t border-b border-gray-400 px-4 py-2 text-center"
          colSpan="6"  // Assuming 3 columns: delivery date, kitchen name, ingredient name
        >
          <strong>
            {new Date(group[0].delivery_date).toLocaleDateString("id-ID", {
              year: "numeric",
              month: "long",
              day: "2-digit",
            })}
          </strong>
        </td>
      </tr>

      {/* Render the actual rows for this group */}
      {group.map((item, index) => {
        return (
          <tr>
            <td
              className={`border-b border-gray-400 px-4 py-2 ${item.qty_do !== null ? "bg-green-500 bg-opacity-20" : ""}`}
            >
              {item.kitchen_name}
            </td>
        
            <td
              className={`border-b border-gray-400 px-4 py-2 ${item.qty_do !== null ? "bg-green-500 bg-opacity-20" : ""}`}
            >
              {item.ingredient_name}
            </td>        
            {/* <td className={`border-b border-gray-400 px-4 py-2 text-right ${item.qty_do !== null ? "bg-green-500 bg-opacity-20" : ""}`}>
              {localDateString(new Date(item.delivery_date))}
            </td> */}
            <td className={`border-b border-gray-400 px-4 py-2 text-right ${item.qty_do !== null ? "bg-green-500 bg-opacity-20" : ""}`}>
            {formatNumber(item.qty_order)}</td>

<td className={`border-b border-gray-400 px-4 py-2 text-right ${item.qty_do !== null ? "bg-green-500 bg-opacity-20" : ""}`}>
            
            {formatNumber(item.stock)}
            </td>

            <td className={`border-b border-gray-400 px-4 py-2 ${item.qty_do !== null ? "bg-green-500 bg-opacity-20" : ""}`}>
              <input
                type="text"
                value={item.qty_do !== null ? item.qty_do : formatNumber(
                  editableRows[item.index]?.edited_qty ?? calculateEditableQtyAndRemainingQty(item.index, data).editableQty
                )}
                className="border rounded px-2 py-1 text-right"
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/[^\d]/g, ""); // Remove non-numeric characters
                  const numericValue = parseInt(rawValue, 10) || 0; // Parse as integer
                  handleOrderQtyChange(item.index, numericValue); // Update the raw value in state
                }}
                disabled={item.qty_do !== null}
              />
            </td>

            <td className={`border-t border-b border-gray-400 px-4 py-2 text-center ${item.qty_do !== null ? "bg-green-500 bg-opacity-20" : ""}`}>
              {formatNumber(
                (editableRows[item.index]?.edited_qty ??
                  calculateEditableQtyAndRemainingQty(item.index, data).editableQty) - 
                  item.qty_order
              )}
            </td>
  {/* 
  {(index === 0 || data[index - 1].ingredient_name !== item.ingredient_name) && (
    <td
      className="border-t border-b border-gray-400 px-4 py-2 text-center"
      rowSpan={data.filter(d => d.ingredient_name === item.ingredient_name).length}
    >
      <button
        className="px-4 py-2 bg-blue-500 text-white rounded"
        onClick={() => {
          // Group all rows with the same ingredient name
          const groupItems = data.filter(d => d.ingredient_name === item.ingredient_name);
          handleDownloadPDF(groupItems);
        }}
      >
        Download PDF
      </button>
    </td> 
  )}*/}
                      </tr>
    
        
        );
      })}
    </tbody>
  );
})}
              </table>
            ) : (
              <p>No data available for the selected date.</p>
            )}
          </div>
        )}

        
      </div>
    );
  }
